@if (facade.shouldDisplaySum$ | async) {
  <div class="row mt-4">
    <div class="col zero-text p-bigger-bold">{{ 'trade.multi-order.create.summary.headline' | transloco }}</div>
  </div>
  <hr />
  <div class="row justify-content-between">
    <div class="col">{{ 'trade.multi-order.create.summary.buy' | transloco }}</div>
    <div class="col text-right" data-zid="estimated-buy-sum">-{{ facade.estimatedBuySum$ | async | currency }}</div>
  </div>
  <hr />
  <div class="row justify-content-between">
    <div class="col">{{ 'trade.multi-order.create.summary.sell' | transloco }}</div>
    <div class="col text-right" data-zid="estimated-sell-sum">{{ facade.estimatedSellSum$ | async | currency }}</div>
  </div>
  <hr />
  <div class="row">
    <div class="col text-right sum" data-zid="estimated-sum">{{ facade.estimatedSum$ | async | currency }}</div>
  </div>
}
